import Card from '@mui/material/Card';
import { useEffect, useState } from 'react';

import Layout from '../../components/layout';
import UserDepartment from '../../models/userDepartment/UserDepartment';
import UserService from '../../services/UserService';
import { useParams } from 'react-router-dom';
import { DecryptData, jsonParser } from '../../helpers/helper';
interface RouteParams {
  id?: string; // Optional because `id` might not be present
}
export default function UserProfile() {
  const { id } = useParams<RouteParams>(); 
  const [userData, setUserData] = useState({});
  const [imageSrc, setImageSrc] = useState('');
  const [imageLoadError, setImageLoadError] = useState(false);
 
  useEffect(() => {
    const storedUser = localStorage.getItem('user');

    const parsedUser = JSON.parse(storedUser);

    const fetchUserData = async () => {
      const user_details = await UserService.findOne(id?id:parsedUser.id);
      const decryptData=await DecryptData(user_details);
      const parsedData=jsonParser(decryptData);

      const userDetails = {
        id: parsedUser.id,
        email: DecryptData(parsedData.email),
        address: DecryptData(parsedData.address),
        phone_no: DecryptData(parsedData.phone_no),
        dob: parsedData.dob,
        roleId: 5,
        role_name: DecryptData(parsedData.role.role),
        joiningDate: parsedData.joiningDate,
        is_active: true,
        full_name: DecryptData(parsedData.full_name),
      };
       
      setUserData(userDetails);
    };

    const fetchImage = async () => {
      try {
        const token = localStorage.getItem('token');

        const response = await fetch(
          `https://hrportals.ainsofttech.com/api/api/users/proile_image/${parsedUser.id}`,
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.ok) {
          const blob = await response.blob();
          const imageUrl = URL.createObjectURL(blob);
          setImageSrc(imageUrl);
          setImageLoadError(false);
        } else {
          setImageLoadError(true);
        }
      } catch (error) {
        setImageLoadError(true);
      }
    };

    fetchUserData();
    fetchImage();
  }, []);

  
  return (
    <Layout>
      <div className="profile__screen">
        <h4 className="responsive_screens_heading">Profile Screen</h4>
        <div className="dashboard__first">
          <Card className="profile__card" variant="outlined">
            <div
              style={{
                borderBottomWidth: '1px',
                borderBottomStyle: 'solid',
                borderBottomColor: 'rgba(112, 112, 112, 0.15)',
              }}
            >
              <div className="profile__screen__body">
                <div className="profile__image">
                  {imageLoadError ? (
                    <img
                      style={{
                        maxWidth: '100%',
                        height: '80%',
                        borderRadius: '15px',
                        margin: 'auto',
                      }}
                      src="/avatar_male.png"
                      alt="Avatar"
                    />
                  ) : (
                    <img
                      style={{
                        maxWidth: '100%',
                        height: '80%',
                        borderRadius: '15px',
                        margin: 'auto',
                      }}
                      src={imageSrc}
                      alt="User Profile"
                    />
                  )}
                </div>

                <div className="profile__body">
                  <div className="profile__body_header">
                    <h3 className="profile__headings">
                      {userData["full_name"]}
                    </h3>
                    <p
                      className="profile__paragraph"
                      style={{ marginTop: '1vw' }}
                    >
                      {userData['designation_name']}
                    </p>
                  </div>
                  <div className="profile__body_body">
                    <div
                      className="profile__body_details"
                      style={{ paddingRight: '10vw' }}
                    >
                      <div className="profile__body_single_detail">
                        <h3 className="profile__headings">Phone no.</h3>
                        <p className="profile__paragraph">
                          {userData['phone_no']?userData['phone_no']:"--"}
                        </p>
                      </div>
                      <div className="profile__body_single_detail">
                        <h3 className="profile__headings">E-mail</h3>
                        <p className="profile__paragraph">
                          {userData['email']?userData['email']:"--"}
                        </p>
                      </div>
                      <div className="profile__body_single_detail">
                        <h3 className="profile__headings">Address</h3>
                        <p className="profile__paragraph">
                          {userData['address']?userData['address']:"--"}
                        </p>
                      </div>
                    </div>
                    <div className="profile__body_details">
                      <div className="profile__body_single_detail">
                        <h3 className="profile__headings">Department</h3>
                        <p className="profile__paragraph">
                          {userData["role_name"]?userData['role_name']:"Admin"}
                        </p>
                      </div>
                      <div className="profile__body_single_detail">
                        <h3 className="profile__headings">Joining Date</h3>
                        <p className="profile__paragraph">
                          {userData['role_name']!=="customer" ?
                           userData['joiningDate'] ? userData['joiningDate']
                            : '8 November, 2021' : "--"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </Layout>
  );
}
